import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, view, roles = [] }) => {
  const { initialized, canAccessView,isPasswordDefault  } = useAuth();

  // Ainda carregando auth → não renderiza nada
  if (!initialized) return null;

  const allowed = canAccessView({ view, roles });

  if (!allowed) {
    // 🔑 prioridade ABSOLUTA: reset de senha
    if (!isPasswordDefault && view !== "resetSenha") {
      return <Navigate to="/redefinirSenha" replace />;
    }

    return <Navigate to="/notFound" replace />;
  }

  return children;
};

export default ProtectedRoute;